module.exports = __webpack_public_path__ + "fonts/TTNormsPro-ExtraBold.a57ff8c9.eot";